import { render } from "./UgmMachines.vue?vue&type=template&id=ee9094b8&scoped=true"
import script from "./UgmMachines.vue?vue&type=script&lang=js"
export * from "./UgmMachines.vue?vue&type=script&lang=js"

import "./UgmMachines.vue?vue&type=style&index=0&id=ee9094b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee9094b8"]])

export default __exports__